// extracted by mini-css-extract-plugin
export var divider = "_1l-0";
export var dividerText = "_1l-2";
export var dividerVertical = "_1l-1";